import type { ClassificationResult } from "./engine.types.js";

/**
 * Turns a ClassificationResult into a human-readable reconstruction, used
 * only by the dev/flag-gated trace panel (src/debug/trace-panel.ts). Never
 * imported by the public result screen.
 */
export function explainTrace(result: ClassificationResult): string[] {
  const lines: string[] = [];
  lines.push(`Engine ${result.engineVersion} · Content ${result.contentVersion}`);
  lines.push(`Estado final: ${result.state} (consistencia: ${result.consistency})`);
  if (result.primaryHypothesis) {
    lines.push(`Hipótesis principal: ${result.primaryHypothesis}`);
  }
  if (result.alternativeHypothesis) {
    lines.push(`Alternativa: ${result.alternativeHypothesis}`);
  }
  if (result.reasonForOpenState) {
    lines.push(`Razón de estado abierto/insuficiente: ${result.reasonForOpenState}`);
  }
  if (result.differentiator) {
    lines.push(`Pregunta de diferenciación usada: ${result.differentiator}`);
  }
  lines.push("--- Answer trace ---");
  for (const step of result.decisionTrace) {
    const weights = Object.entries(step.weightChanges)
      .map(([id, w]) => `${id}:${w! > 0 ? "+" : ""}${w}`)
      .join(", ");
    lines.push(
      `[${step.questionId} → ${step.optionId}] pesos(${weights}) señales(${step.signalsAdded.join("; ") || "—"})`,
    );
    if (step.counterevidenceAdded.length) {
      lines.push(`    contraevidencia: ${step.counterevidenceAdded.join("; ")}`);
    }
  }
  lines.push("--- Evidencia acumulada ---");
  lines.push(result.evidence.join("; ") || "—");
  lines.push("--- Contraevidencia acumulada ---");
  lines.push(result.counterevidence.join("; ") || "—");
  return lines;
}
